import { useEffect, useMemo, useRef, useState } from "react"
import { langStore } from "@/stores/lang-store"
import { periodStore } from "@/components/detail-modal/period-store"
import FilterIcon from "../icons/filter-icon"
const formatDisplayValue = (dateStr, lang = "ko") => {
  if (!dateStr) return ""
  const [y, m] = dateStr.split("-")

  if (lang === "ko") {
    return `${y}년 ${parseInt(m)}월`
  } else {
    const date = new Date(parseInt(y), parseInt(m) - 1, 1)
    return date.toLocaleString("en-US", { month: "short", year: "numeric" })
  }
}
const CustomMonthInput = ({ label, value, onChange, lang }) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-semibold text-gray-500 ml-1">{label}</span>
      <div className="relative w-full h-10 bg-gray-50 border border-gray-200 rounded-lg flex items-center px-3">
        <span className="text-sm text-gray-800 font-medium w-full">
          {formatDisplayValue(value, lang) || "-"}
        </span>
        <input
          type="month"
          value={value || ""}
          onChange={onChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        />
        <span className="absolute right-3 text-gray-400 pointer-events-none">📅</span>
      </div>
    </div>
  )
}

const PeriodSettingMobile = ({ bundle, onPeriodSearch }) => {
  const { lang } = langStore()
  const { startDate, endDate, setStartDate, setEndDate, active, setActive } = periodStore()

  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  const [localStartDate, setLocalStartDate] = useState(startDate)
  const [localEndDate, setLocalEndDate] = useState(endDate)

  useEffect(() => {
    if (open) {
      // setLocalStartDate(startDate)
      // setLocalEndDate(endDate)
    }
  }, [open, startDate, endDate])

  const toMonthStr = (dateStr) => (dateStr && dateStr.length >= 7 ? dateStr.slice(0, 7) : "")

  const activeLabel = useMemo(() => {
    const found = bundle.dateFilters.find((v) => v.key === active)
    return found ? found.label[lang] : null
  }, [active, bundle.dateFilters, lang])

  const summaryText =
    activeLabel ?? `${formatDisplayValue(startDate) || "-"} ~ ${formatDisplayValue(endDate) || "-"}`

  useEffect(() => {
    if (!open) return
    const onDown = (e) => {
      if (!rootRef.current) return
      if (!rootRef.current.contains(e.target)) setOpen(false)
    }
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false)
    }
    document.addEventListener("mousedown", onDown)
    document.addEventListener("touchstart", onDown)
    document.addEventListener("keydown", onKey)
    return () => {
      document.removeEventListener("mousedown", onDown)
      document.removeEventListener("touchstart", onDown)
      document.removeEventListener("keydown", onKey)
    }
  }, [open])

  return (
    <div ref={rootRef} className="relative mb-2">
      {/* Header */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-3 py-2 rounded-xl border border-[#e5e8eb] bg-white"
      >
        <div className="flex items-center gap-2">
          <FilterIcon />
          <span className="font-semibold">{bundle.filter.periodSettings[lang]}</span>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600 truncate max-w-[45vw]">{summaryText}</span>
          <span className={`text-gray-500 transition-transform ${open ? "rotate-180" : ""}`}>
            ▾
          </span>
        </div>
      </button>

      {/* Panel */}
      {open && (
        <div
          className="
            absolute top-full left-0 right-0 z-50 mt-1
            rounded-xl border border-[#e5e8eb] bg-white shadow-lg
          "
          onClick={(e) => e.stopPropagation()}
        >
          <div className="p-3 space-y-3">
            <div className="grid grid-cols-2 gap-2">
              <CustomMonthInput
                label={bundle.filter.startDate[lang]}
                value={toMonthStr(localStartDate)}
                onChange={(e) => {
                  setLocalStartDate(e.target.value ? `${e.target.value}-01` : "")
                }}
                lang={lang}
              />
              <CustomMonthInput
                label={bundle.filter.endDate[lang]}
                value={toMonthStr(localEndDate)}
                onChange={(e) => {
                  const val = e.target.value
                  if (val) {
                    const [y, m] = val.split("-")
                    const lastDay = new Date(y, m, 0).getDate()
                    setLocalEndDate(`${val}-${lastDay}`)
                  } else {
                    setLocalEndDate("")
                  }
                }}
                lang={lang}
              />
            </div>

            {/* Search button */}
            <button
              onClick={() => {
                setActive(null)
                setStartDate(localStartDate)
                setEndDate(localEndDate)
                onPeriodSearch({
                  startDate: localStartDate,
                  endDate: localEndDate
                })
                setOpen(false)
              }}
              className="w-full py-2 rounded-lg bg-[rgba(0,27,55,0.1)] font-semibold hover:bg-[rgba(0,27,55,0.2)]"
            >
              {bundle.search[lang]}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default PeriodSettingMobile
